import makeStyles from "@mui/styles/makeStyles";
import { OverFlowTipProps } from "./OverFlowTip";

export const useStyles = makeStyles(() => ({
  text: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: (props: OverFlowTipProps) =>
      props.onClick ? "pointer" : "initial",
  },
}));
